import ResizableContainer from "../core/ResizableContainer";
import ResizableScene from "../core/ResizableScene";
import ArrayUtils from "../utils/ArrayUtils";
import HiddenObjectThumbnail from "./HiddenObjectThumbnail";

export default class HiddenObjectBar extends ResizableContainer {
	private MaxThumbnails = 9;

	itemContainer: Phaser.GameObjects.Container;
	slots: Phaser.GameObjects.Container[];
	items: HiddenObjectThumbnail[];

	scene: ResizableScene;

	_resize: () => void;

	private padding = 0;

	constructor(scene: ResizableScene, width: number) {
		super(scene, 0, 0);

		this.items = [];
		this.slots = [];

		this.setSize(width, 200);

		const background = scene.add.image(0, 0, "objectBar");
		background.setSize(background.width, 400);
		background.setDisplaySize(background.width, 400);
		this.add(background);

		const flurryBackground = scene.add.image(0, 0, "objectBarDogBacker");
		flurryBackground.setSize(300, 300);
		flurryBackground.setDisplaySize(300, 300);
		this.add(flurryBackground);

		// const flurryFrame = scene.add.image(0, 0, "objectBarDogBacker");
		// flurryFrame.setTint(0xadd8e6);
		// flurryFrame.setSize(250, 250);
		// flurryFrame.setDisplaySize(250, 250);
		// this.add(flurryFrame);

		const flurry = scene.add.image(0, 0, "objectBarDog");
		flurry.setSize(300, 300);
		flurry.setDisplaySize(300, 300);
		this.add(flurry);

		// const flurryText = scene.add.text(0, 0, "Flurry", {
		// 	fontFamily: Fonts.DefaultFont,
		// 	fontSize: "64px",
		// 	color: GameColors.WHITE,
		// });
		// this.add(flurryText);

		const itemContainer = (this.itemContainer = scene.add.container(0, 0));
		itemContainer.setSize(background.width * 0.8, 200);
		this.add(itemContainer);

		for (let i = 0; i < this.MaxThumbnails; i++) {
			const slot = scene.add.container(0, 0);
			this.scene.alignTo.LeftCenter(slot, this.itemContainer, -35 - this.padding * i);
			this.slots.push(slot);
		}

		// Uncomment to see item container dimensions
		// const itemDebug = scene.add.image(0, 0, "whiteSquare");
		// itemDebug.setTint(0xadd8e6);
		// itemDebug.setDisplaySize(itemContainer.width, itemContainer.height);
		// itemContainer.add(itemDebug);

		this._resize = (): void => {
			this.padding = itemContainer.width / 9;
			scene.alignIn.LeftCenter(flurryBackground, background, 20, -20);
			// scene.alignIn.Center(flurryFrame, flurryBackground);
			scene.alignIn.Center(flurry, flurryBackground);
			// scene.alignIn.Center(flurryText, flurry);
			scene.alignIn.Center(itemContainer, background, flurryBackground.displayWidth / 2 - 20, 5);

			for (let i = 0; i < this.MaxThumbnails; i++) {
				this.scene.alignTo.LeftCenter(this.slots[i], this.itemContainer, 85 - this.padding * i);
				// if (this.items.length <= i) this.scene.alignIn.Center(this.items[i], this.slots[this.items.length]);
			}
		};
		this.resize();
	}

	addThumbnail(texture: string, id: number): void {
		if (this.items.length == this.MaxThumbnails) this.reorganizeThumbnails();
		const thumbnail = new HiddenObjectThumbnail(this.scene, texture, id);
		this.itemContainer.add(thumbnail);
		this.scene.alignIn.Center(thumbnail, this.slots[this.items.length]);
		this.items.push(thumbnail);
	}

	reorganizeThumbnails(): void {
		const firstFoundItem = this.items.find((t) => t.isFound === true);
		if (firstFoundItem) {
			firstFoundItem.dismiss();
			ArrayUtils.remove(this.items, firstFoundItem);
		} else {
			return;
		}

		for (let i = 0; i < this.items.length; i++) {
			this.scene.tweens.add({
				targets: this.items[i],
				duration: 450,
				x: this.slots[i].x,
				y: this.slots[i].y,
				ease: Phaser.Math.Easing.Quadratic.Out,
			});
		}
	}

	onFindObject(id: number): void {
		const thumbnail = this.items.find((t) => t.id === id);
		if (thumbnail) thumbnail.found();
	}

	checkSpaceAvailable(): boolean {
		if (this.items.length == 9 && this.items.filter((t) => t.isFound === true).length == 0) return false;
		return true;
	}

	resize(): void {
		super.resize();
		if (this._resize) this._resize();
	}
}
